<script setup>
import { useGlobalStore } from '@stores/global'

import FaqCard from '@components/global/faq-card.vue'

const global = useGlobalStore()
</script>
<template>
	<div class="bg-bgSecondary">
		<section class="container flex flex-col items-center gap-8">
			<span class="h9">FAQ</span>
			<h4>Frequently Asked Questions</h4>
			<div class="flex flex-col gap-4">
				<FaqCard v-for="faq in global.faqs" :faq="faq" />
			</div>
		</section>
	</div>
</template>
<style scoped></style>
